import * as React from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';

interface IExcelReportDialogProps {
    dialogName: string;
    hideDialog: () => void;
    periodNo?: number;
    generating: boolean;
    message?: string;
    onConfirm: (filename: string) => void;
}

// Mirrors the real Oracle "Excel" screen (block EXCEL, reached via Go_Block('Excel') off the main
// screen's Excel Report button) - just a Filename field and OK/Cancel, per the screenshot. The
// live OK trigger (oid 294; oid 292/293 are dead, prefixed OLD_) requires a filename, builds the
// file server-side (xl_Payroll_Summary), and downloads it - the file-save-dialog "browse" button
// (oid 289) isn't reproduced since the browser's own download flow already covers that role, same
// as TextExportDialog does for the analogous Text Export screen.
const ExcelReportDialog = (props: IExcelReportDialogProps) => {
    const { register, getValues } = useForm();

    // Same reasoning as TextExportDialog's own defaultFilename - the dialog remounts fresh each
    // open (unmountOnExit), so this is computed inline rather than set via a one-time useEffect.
    const defaultFilename = props.periodNo ? `Employee Pay - ${props.periodNo}.xlsx` : 'Employee Pay.xlsx';

    const handleConfirm = () => {
        const values = getValues();
        props.onConfirm(values.filename || defaultFilename);
    };

    return (
        <Dialog title="Excel Report" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div className="form-row" style={{ alignItems: 'center', marginBottom: '.75rem' }}>
                <label style={{ width: '30%' }}>Filename</label>
                <RHFInputBox
                    name="filename"
                    type="text"
                    register={register}
                    defaultVal={defaultFilename}
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '70%' }}
                />
            </div>
            {!!props.message && (
                <div style={{ color: 'red', textAlign: 'center', marginBottom: '.75rem' }}>{props.message}</div>
            )}
            <div className="form-row" style={{ marginTop: '1rem', justifyContent: 'center' }}>
                <Button
                    className="blue-hover-button"
                    style={{ width: 'auto', marginRight: '1rem' }}
                    text={props.generating ? 'Generating...' : 'Generate'}
                    disabled={props.generating}
                    loading={props.generating}
                    onClick={handleConfirm}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: 'auto' }}
                    text="Cancel"
                    disabled={props.generating}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default ExcelReportDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/employeePayroll/ExcelReportDialog.tsx